import { Box } from "@material-ui/core";
import { get } from "lodash";
import React from "react";
import {
	ChipField,
	EditButton,
	List as RaList,
	TextField,
	UrlField,
} from "react-admin";
import ResponsiveList from "../components/lists/ResponsiveList";
import { useListStyles } from "../components/lists/useStyles";
import perPage from "../utils/per-page";
import Actions from "./Actions";
import CloneButton from "./buttons/CloneButton";
import IsDefaultField from "./fields/IsDefaultField";
import Filters from "./Filters";

export const ShortUrlField = ({ source, record, width }) => (
	<div style={{ width: width || window.innerWidth - 48, whiteSpace: "nowrap" }}>
		<Box component="div" my={2} textOverflow="ellipsis" overflow="hidden">
			<UrlField source={source} record={record} />
		</Box>
	</div>
);

const Datagrid = (props) => {
	const hasBookmakerFilter = !!get(props, "filterValues.bookmaker_id");
	return (
		<ResponsiveList
			{...props}
			mobileHeader={
				<React.Fragment>
					<TextField
						source="name"
						variant="subtitle1"
						style={{ fontWeight: "bold" }}
					/>
					<EditButton />
				</React.Fragment>
			}
			mobileBody={
				<React.Fragment>
					{!hasBookmakerFilter && <TextField source="bookmaker.name" />}
					<ShortUrlField source="url" />
				</React.Fragment>
			}
		>
			<TextField source="id" label="ID" style={{ fontWeight: "bold" }} />
			{!hasBookmakerFilter && (
				<ChipField style={{ marginLeft: 0 }} source="bookmaker.name" />
			)}
			<TextField source="name" />
			<ShortUrlField source="url" width={250} />
			<IsDefaultField source="is_default" />
			<EditButton />
			<CloneButton />
		</ResponsiveList>
	);
};

const List = (props) => {
	const classes = useListStyles();
	return (
		<RaList
			{...props}
			classes={classes}
			filters={<Filters />}
			actions={<Actions />}
			perPage={perPage()}
			sort={{ field: "id", order: "DESC" }}
		>
			<Datagrid {...props} />
		</RaList>
	);
};
export default List;
